export default __webpack_public_path__ + "static/media/Nxrmal_Lo_Shoes_Roughness.96a37940.tga";